angular.module('managers').service('Manager', function (BASE_PATH, $resource) {
  return $resource(BASE_PATH.API_URL+'manager/:idCustomer', { idCustomer:'@id'});
});
